/**
 * Generated bundle index. Do not edit.
 */

export * from './public_api';

export {NgxDropzoneLabelDirective as ɵb} from './lib/ngx-dropzone-label.directive';
export {NgxDropzoneService as ɵa} from './lib/ngx-dropzone.service';